module.exports = [{
      plugin: require('/Users/dominikbroj/dev/pwkp/frontend/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
